import styled from 'styled-components';

export const MainContainer = styled.div`
  height: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  & > div:last-child {
    display: flex;
  }
`;

export const BodyContainer = styled.div`
  margin-top: 25px;
`;
